export function toUnderscoreUpper(pascalStr: string) {
  return pascalStr
    .match(/[A-Z][a-z]+/g)
    ?.join("_")
    .toUpperCase();
}

/** Strip HTML tags, decode entities and collapse the result to a single line. */
export function stripHtml(html: string): string {
  const spaced = html.replace(
    /<br\s*\/?>|<\/(p|div|li|h[1-6]|tr|blockquote)>/gi,
    " ",
  );
  const text =
    new DOMParser().parseFromString(spaced, "text/html").body.textContent ?? "";

  return text.replace(/\s+/g, " ").trim();
}

export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // Remove special characters except hyphens and spaces
    .replace(/[\s_-]+/g, "-") // Replace spaces, underscores, and multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ""); // Remove hyphens from start and end
}
